import { render, staticRenderFns } from "./overview1.vue?vue&type=template&id=d2673250&scoped=true"
import script from "./overview1.vue?vue&type=script&lang=js"
export * from "./overview1.vue?vue&type=script&lang=js"
import style0 from "./overview1.vue?vue&type=style&index=0&id=d2673250&prod&scoped=true&lang=less"
import style1 from "./overview1.vue?vue&type=style&index=1&id=d2673250&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2673250",
  null
  
)

export default component.exports